module.exports = __webpack_public_path__ + "30afcb94a94abd670c91bcbf2fc0ad36.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/coh_image_3.png
// module id = 133
// module chunks = 0